import React from 'react';
import { IAuditoriaTransferPricingResultado } from '../interfaces/IAuditoriaTransferPricing';
import { TributoAuditoria } from '../interfaces/IAuditoria';

interface Props {
  resultado?: IAuditoriaTransferPricingResultado;
  onSelecionar: (tributo: TributoAuditoria) => void;
}

const formatCurrency = (value?: number) =>
  (value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

const AuditoriaResumoTransferPricing: React.FC<Props> = ({ resultado, onSelecionar }) => {
  if (!resultado) return null;

  const totalItens = resultado.itens?.length || 0;
  const itensEmErro = resultado.itens?.filter(i => i.status === 'ERRO').length || 0;

  return (
    <div className='auditoria-card mt-5'>
      <h3>Resumo de Auditoria Preventiva — Transfer Pricing e Intercompany</h3>
      <p className='text-muted'>
        Monitoramento de transações com partes relacionadas — contas de resultado (3.01.01.06.01 e
        3.01.02.04.05) e contas patrimoniais de mútuo/intercompany (Ativo/Passivo). A ausência de
        ajuste na conta 6.01.01.01.01 gera ERRO CRÍTICO com projeção de passivo máximo: 34% de
        imposto (IRPJ + CSLL) + 75% de multa qualificada + 3% de multa acessória. Indícios
        patrimoniais de mútuo/intercompany geram AVISO, sem cálculo automático. Clique para ver a
        análise detalhada.
      </p>

      <div className='table-responsive mt-4'>
        <table className='auditoria-table auditoria-table-tributos'>
          <thead>
            <tr>
              <th>Auditoria</th>
              <th className='text-end'>Risco Total do Passivo</th>
              <th className='text-end'>Passivo Tributário (34%)</th>
              <th className='text-end'>Multas (75% + 3%)</th>
              <th className='text-center'>Contas Analisadas</th>
              <th className='text-center'>Inconformidades</th>
            </tr>
          </thead>
          <tbody>
            <tr className='auditoria-row-tributo' onClick={() => onSelecionar('AUDITORIA_TRANSFER_PRICING')}>
              <td className='auditoria-col-tributo'>
                <div className='d-flex align-items-center gap-2'>
                  <strong>Transfer Pricing e Intercompany</strong>
                  <span className={`auditoria-status status-${resultado.status}`}>
                    {resultado.status}
                  </span>
                </div>
                <div className='auditoria-legislacao-inline'>
                  <div>
                    {totalItens} conta{totalItens === 1 ? '' : 's'} de partes relacionadas analisada{totalItens === 1 ? '' : 's'} no período
                  </div>
                  <div className='text-muted'>{resultado.mensagemDirecionamento}</div>
                </div>
              </td>
              <td className='text-end auditoria-col-highlight'>
                {formatCurrency(resultado.exposicaoFinanceiraTotalGeral)}
                <div className='auditoria-kpi-help'>
                  Etotal = Pi + Multa Qualificada (75%) + Multa Acessória (3%)
                </div>
              </td>
              <td className='text-end'>
                {formatCurrency(resultado.passivoTributarioPrincipalTotal)}
                <div className='auditoria-kpi-help'>IRPJ (25%) + CSLL (9%)</div>
              </td>
              <td className='text-end'>
                {formatCurrency(resultado.multaQualificadaTotal + resultado.multaAcessoriaTotal)}
                <div className='auditoria-kpi-help'>Lei 9.430/96 Art. 44 + Lei 8.218/91 Art. 12</div>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador'>{totalItens}</span>
              </td>
              <td className='text-center'>
                <span className={`auditoria-contador ${itensEmErro > 0 ? 'auditoria-contador-erro' : ''}`}>
                  {itensEmErro}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuditoriaResumoTransferPricing;
